<template>
  <div class="adyen-disputes-wrapper">
    <center v-show="loading" class="grey-text">
      <i class="fas fa-spinner fa-spin grey-text"></i>
      Loading...
    </center>
    <div ref="container"></div>
  </div>
</template>

<script>
  // Webpacker 5 uses webpack 4, which ignores the package "exports" map, so we
  // import the real dist files directly (the package ships no main/module field).
  import { AdyenPlatformExperience, DisputesOverview } from '@adyen/adyen-platform-experience-web/dist/es/index.js';
  import '@adyen/adyen-platform-experience-web/dist/adyen-platform-experience-web.css';

  export default {
    name: 'AdyenDisputes',
    props: {
      environment: { type: String, default: 'test' },
    },
    data() {
      return { loading: true };
    },
    async mounted() {
      try {
        this.core = await AdyenPlatformExperience({
          onSessionCreate: this.handleSessionCreate,
          environment: this.environment,
          locale: 'en-US',
        });

        this.overview = new DisputesOverview({ core: this.core });
        this.overview.mount(this.$refs.container);
      } finally {
        this.loading = false;
      }
    },
    beforeDestroy() {
      if (this.overview && typeof this.overview.unmount === 'function') {
        this.overview.unmount();
      }
    },
    methods: {
      async handleSessionCreate() {
        const response = await fetch('/merchant/dispute_sessions', {
          method: 'POST',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          },
          credentials: 'same-origin',
        });

        if (!response.ok) throw new Error('Failed to create Adyen dispute session');

        return response.json();
      },
    },
  };
</script>

<style>
  /* Hide Adyen's stock illustration in the empty state. Adyen renders the
     image inside .adyen-pe-error-message-display__illustration; hiding that
     wrapper keeps the heading + helper copy intact. */
  .adyen-disputes-wrapper .adyen-pe-error-message-display__illustration {
    display: none !important;
  }

  /* Drop the outer card border so the embed blends with the page. */
  .adyen-disputes-wrapper .adyen-pe-component__container {
    border: none !important;
  }

  /* Hide Adyen's built-in small "Disputes" title — we render our own <h3>
     above the embed to match the heading style on sibling tabs (Bad Checks). */
  .adyen-disputes-wrapper .adyen-pe-header__title {
    display: none !important;
  }
</style>
